import { debounce } from 'lodash-es'

import { API } from '../API'

const TRACKING_EVENTS = ['click', 'mousemove', 'mousedown', 'keydown']
const DEBOUNCE_INTERVAL = 5 * 60 * 1000

export class AnalyticsStore {
  private API: API
  private readonly debouncedTrackingFunction: () => void

  constructor(API: API) {
    this.API = API
    this.debouncedTrackingFunction = debounce(() => {
      this.API.users.updateInteraction().catch(() => {
        /* ignore analytics update errors for expired token */
      })
    }, DEBOUNCE_INTERVAL)
  }

  public addTrackingListeners() {
    const body = document.getElementsByTagName('body')[0]
    TRACKING_EVENTS.forEach((event) => {
      body.addEventListener(event, this.debouncedTrackingFunction)
    })
  }

  public removeTrackingListeners() {
    const body = document.getElementsByTagName('body')[0]

    TRACKING_EVENTS.forEach((event) => {
      body.removeEventListener(event, this.debouncedTrackingFunction)
    })
  }
}
